import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './AddFormModal.css';

const AddFormModal = ({
  isOpen,
  title,
  onClose,
  onSubmit,
  footer,
  children,
  className = ''
}) => {
  if (!isOpen) return null;

  return (
    <div className={`afm-overlay ${className}`.trim()} onClick={onClose}>
      <div className="afm-card" onClick={(e) => e.stopPropagation()}>
        <form className="afm-form" onSubmit={onSubmit}>
          <div className="afm-head">
            <h5 className="afm-title">{title}</h5>
            <button type="button" className="afm-close" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div className="afm-body">{children}</div>
          <div className="afm-foot">{footer}</div>
        </form>
      </div>
    </div>
  );
};

export default AddFormModal;
